import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiDisbursement } from "@/types";

export const deleteDisbursementDraft = async (
  token: string,
  draftId: string,
): Promise<ApiDisbursement> => {
  const response = await fetch(`${API_URL}/disbursements/${draftId}`, {
    method: "DELETE",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  return handleApiResponse(response);
};
